import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://core.nalas-observatory.eu'
})

export default instance